// Customizer const
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSE_MENU";
export const WINDOW_WIDTH = "WINDOW-WIDTH";
export const SWITCH_LANGUAGE = "SWITCH-LANGUAGE";
export const FETCH_APP_VERSION = "FETCH_APP_VERSION";
export const PAGE_SETTING_FORM_VISIBLE_TOGGLE = "PAGE_SETTING_FORM_VISIBLE_TOGGLE";

//Contact Module const
export const FETCH_DATA_START = "FETCH_DATA_START";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const FETCH_START = "fetch_start";
export const FETCH_SUPER_START = "FETCH_SUPER_START";
export const FETCH_SUCCESS = "fetch_success";
export const FETCH_ERROR = "fetch_error";
export const DOWNLOAD_PROGRESS = "DOWNLOAD_PROGRESS";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const ON_HIDE_LOADER = "ON_HIDE_LOADER";

export const FETCH_FILTER = "FETCH_FILTER";
export const FETCH_FILTER_SUCCESS = "FETCH_FILTER_SUCCESS";
export const FETCH_PAGE_SETTING_FILTER_SUCCESS = "FETCH_PAGE_SETTING_FILTER_SUCCESS";
export const FETCH_MODULE_SUCCESS = "FETCH_MODULE_SUCCESS";
export const FETCH_DOCUMENT_REPORT_FILTERS_SUCCESS =
    "FETCH_DOCUMENT_REPORT_FILTERS_SUCCESS";

export const FETCH_SUB_DOCUMENT_FILTER = "FETCH_SUB_DOCUMENT_FILTER";
export const FETCH_SUPER_MASTER_FILTER_SUCCESS =
    "FETCH_SUPER_MASTER_FILTER_SUCCESS";
export const FETCH_SUB_DOCUMENT_FILTER_SUCCESS =
    "FETCH_SUB_DOCUMENT_FILTER_SUCCESS";
export const FETCH_SUB_ELEMENT_FILTER_SUCCESS =
    "FETCH_SUB_ELEMENT_FILTER_SUCCESS";
export const FETCH_PAGE_FIELDS_FILTER_SUCCESS =
    "FETCH_PAGE_FIELDS_FILTER_SUCCESS";

//Auth const
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNIN_GOOGLE_USER = "SIGNIN_GOOGLE_USER";
export const SIGNIN_GOOGLE_USER_SUCCESS = "SIGNIN_GOOGLE_USER_SUCCESS";
export const SIGNIN_FACEBOOK_USER = "SIGNIN_FACEBOOK_USER";
export const SIGNIN_FACEBOOK_USER_SUCCESS = "SIGNIN_FACEBOOK_USER_SUCCESS";
export const SIGNIN_TWITTER_USER = "SIGNIN_TWITTER_USER";
export const SIGNIN_TWITTER_USER_SUCCESS = "SIGNIN_TWITTER_USER_SUCCESS";
export const SIGNIN_GITHUB_USER = "SIGNIN_GITHUB_USER";
export const SIGNIN_GITHUB_USER_SUCCESS = "signin_github_user_success";
export const SIGNIN_USER = "SIGNIN_USER";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const INIT_URL = "INIT_URL";
export const USER_DATA = "user_data";
export const USER_TOKEN_SET = "user_token_set";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const GET_DETAILS_TO_RESET_PASSWORD = "GET_DETAILS_TO_RESET_PASSWORD";
export const SET_ORG_DATA = "SET_ORG_DATA";

//Resource
export const GET_RESOURCE_SUCCESS = "GET_RESOURCE_SUCCESS";
export const CREATE_RESOURCE_SUCCESS = "CREATE_RESOURCE_SUCCESS";
export const FETCH_RESOURCE_SUCCESS = "FETCH_RESOURCE_SUCCESS";
export const SAVE_RESOURCE_QUERY = "SAVE_RESOURCE_QUERY";

//Role
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const CREATE_ROLE_SUCCESS = "CREATE_ROLE_SUCCESS";
export const FETCH_ROLE_SUCCESS = "FETCH_ROLE_SUCCESS";
export const SAVE_ROLE_QUERY = "SAVE_ROLE_QUERY";
export const REFRESH_ROLE_DATA = "REFRESH_ROLE_DATA";

//User
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const SAVE_USER_QUERY = "SAVE_USER_QUERY";

//Organisation
export const GET_ORGANISATION_SUCCESS = "GET_ORGANISATION_SUCCESS";
export const CREATE_ORGANISATION_SUCCESS = "CREATE_ORGANISATION_SUCCESS";
export const FETCH_ORGANISATION_SUCCESS = "FETCH_ORGANISATION_SUCCESS";
export const SAVE_ORGANISATION_QUERY = "SAVE_ORGANISATION_QUERY";
export const FETCH_ORGANISATION_IMPORT_SUCCESS = "FETCH_ORGANISATION_IMPORT_SUCCESS";
export const FETCH_ORGANISATION_SPARE_IMPORT_SUCCESS = "FETCH_ORGANISATION_SPARE_IMPORT_SUCCESS";
export const FETCH_ORGANISATION_DATA_SUCCESS = 'FETCH_ORGANISATION_DATA_SUCCESS';

//Client
export const GET_CLIENT_SUCCESS = "GET_CLIENT_SUCCESS";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const FETCH_CLIENT_SUCCESS = "FETCH_CLIENT_SUCCESS";
export const SAVE_CLIENT_QUERY = "SAVE_CLIENT_QUERY";

//Asset Stock Taking
export const GET_ASSET_STOCK_TAKING_SUCCESS = "GET_ASSET_STOCK_TAKING_SUCCESS";
export const CREATE_ASSET_STOCK_TAKING_SUCCESS =
    "CREATE_ASSET_STOCK_TAKING_SUCCESS";
export const FETCH_ASSET_STOCK_TAKING_SUCCESS =
    "FETCH_ASSET_STOCK_TAKING_SUCCESS";
export const SAVE_ASSET_STOCK_TAKING_QUERY = "SAVE_ASSET_STOCK_TAKING_QUERY";
export const CLEAR_ASSET_STOCK_TAKING_DATA_SUCCESS =
    "CLEAR_ASSET_STOCK_TAKING_DATA_SUCCESS";
export const ASSET_STOCK_TAKING_UPLOAD_COUNT_INCREASE =
    "ASSET_STOCK_TAKING_UPLOAD_COUNT_INCREASE";
export const ASSET_STOCK_TAKING_UPLOAD_COUNT_DECREASE =
    "ASSET_STOCK_TAKING_UPLOAD_COUNT_DECREASE";
export const CHECK_ASSET_STOCK_TAKING_SUCCESS =
    "CHECK_ASSET_STOCK_TAKING_SUCCESS";
export const GET_AST_COMBINE_REPORT_SUCCESS = 'GET_AST_COMBINE_REPORT_SUCCESS';
export const GET_AST_ASSETS_BY_VOUCHER_SUCCESS = 'GET_AST_ASSETS_BY_VOUCHER_SUCCESS';

// reconciliation
export const GET_RECONCILIATION_ASSETS_BY_VOUCHER_SUCCESS = 'GET_RECONCILIATION_ASSETS_BY_VOUCHER_SUCCESS';


//Pre Verification
export const GET_PRE_VERIFICATION_SUCCESS = "GET_PRE_VERIFICATION_SUCCESS";
export const CREATE_PRE_VERIFICATION_SUCCESS =
    "CREATE_PRE_VERIFICATION_SUCCESS";
export const FETCH_PRE_VERIFICATION_SUCCESS = "FETCH_PRE_VERIFICATION_SUCCESS";
export const SAVE_PRE_VERIFICATION_QUERY = "SAVE_PRE_VERIFICATION_QUERY";
export const CLEAR_PRE_VERIFICATION_STATE_SUCCESS =
    "CLEAR_PRE_VERIFICATION_STATE_SUCCESS";
export const CLEAR_PRE_VERIFICATION_STATE_DATA =
    "CLEAR_PRE_VERIFICATION_STATE_DATA";
export const SAVE_PRE_VERIFICATION_STATE_SUCCESS =
    "SAVE_PRE_VERIFICATION_STATE_SUCCESS";
export const PRE_VERIFICATION_UPLOAD_COUNT_INCREASE =
    "PRE_VERIFICATION_UPLOAD_COUNT_INCREASE";
export const PRE_VERIFICATION_UPLOAD_COUNT_DECREASE =
    "PRE_VERIFICATION_UPLOAD_COUNT_DECREASE";
export const FETCH_ASSET_SUB_TYPE_SUCCESS = "FETCH_ASSET_SUB_TYPE_SUCCESS";
export const FETCH_ASSET_MODELS_SUCCESS = "FETCH_ASSET_MODELS_SUCCESS";
export const CHECK_PRE_VERIFICATION_SUCCESS = "CHECK_PRE_VERIFICATION_SUCCESS";
export const GET_PRE_VERIFICATION_COMBINE_REPORT_SUCCESS = "GET_PRE_VERIFICATION_COMBINE_REPORT_SUCCESS";
export const QR_ALREADY_USED_CHECKED = 'QR_ALREADY_USED_CHECKED';
// Pre Verification Approval
export const GET_PRE_VERIFICATION_APPROVAL_SUCCESS =
    "GET_PRE_VERIFICATION_APPROVAL_SUCCESS";
export const CREATE_PRE_VERIFICATION_APPROVAL_SUCCESS =
    "CREATE_PRE_VERIFICATION_APPROVAL_SUCCESS";
export const FETCH_PRE_VERIFICATION_APPROVAL_SUCCESS =
    "FETCH_PRE_VERIFICATION_APPROVAL_SUCCESS";
export const SAVE_PRE_VERIFICATION_APPROVAL_QUERY =
    "SAVE_PRE_VERIFICATION_APPROVAL_QUERY";
export const CLEAR_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS =
    "CLEAR_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS";
export const CLEAR_PRE_VERIFICATION_APPROVAL_STATE_DATA =
    "CLEAR_PRE_VERIFICATION_APPROVAL_STATE_DATA";
export const SAVE_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS =
    "SAVE_PRE_VERIFICATION_APPROVAL_STATE_SUCCESS";
export const BULK_PROCESS_SUCCESS =
    "BULK_PROCESS_SUCCESS";
export const PV_QR_RESET_PROCESS_SUCCESS =
    "PV_QR_RESET_PROCESS_SUCCESS";
export const GET_PV_BY_VOUCHER_SUCCESS =
    "GET_PV_BY_VOUCHER_SUCCESS";

//Location
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const CREATE_LOCATION_SUCCESS = "CREATE_LOCATION_SUCCESS";
export const FETCH_LOCATION_SUCCESS = "FETCH_LOCATION_SUCCESS";
export const SAVE_LOCATION_QUERY = "SAVE_LOCATION_QUERY";

//Event
export const GET_EVENT_SUCCESS = "GET_EVENT_SUCCESS";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const FETCH_EVENT_SUCCESS = "FETCH_EVENT_SUCCESS";
export const SAVE_EVENT_QUERY = "SAVE_EVENT_QUERY";
export const FETCH_FILTER_FOR_MODULE_SUCCESS =
    "FETCH_FILTER_FOR_MODULE_SUCCESS";
export const FETCH_EVENT_STATUS_SUCCESS = "FETCH_EVENT_STATUS_SUCCESS";
export const FETCH_EVENT_STATUS_START = "FETCH_EVENT_STATUS_START";
export const FETCH_EVENT_STATUS_END = "FETCH_EVENT_STATUS_END";

//Notification
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_SUCCESS = "FETCH_NOTIFICATION_SUCCESS";
export const SAVE_NOTIFICATION_QUERY = "SAVE_NOTIFICATION_QUERY";

//Asset
export const GET_ASSET_SUCCESS = "GET_ASSET_SUCCESS";
export const GET_ASSET_MODEL_BY_SUBTYPE_SUCCESS =
    "GET_ASSET_MODEL_BY_SUBTYPE_SUCCESS";
export const CREATE_ASSET_SUCCESS = "CREATE_ASSET_SUCCESS";
export const FETCH_ASSET_SUCCESS = "FETCH_ASSET_SUCCESS";
export const FETCH_ASSET_FOR_LABEL_SUCCESS = "FETCH_ASSET_FOR_LABEL_SUCCESS";
export const SAVE_ASSET_QUERY = "SAVE_ASSET_QUERY";
export const FETCH_ASSET_CODE_BY_MODEL_ID_SUCCESS =
    "FETCH_ASSET_CODE_BY_MODEL_ID_SUCCESS";
export const GET_ALL_ASSET_TYPE_SUCCESS = "GET_ALL_ASSET_TYPE_SUCCESS";
export const GET_EQUIPMENT_SUB_TYPE_BY_ASSET_TYPES_SUCCESS =
    "GET_EQUIPMENT_SUB_TYPE_BY_ASSET_TYPES_SUCCESS";
export const GET_MODEL_BY_ASSET_MAKES_SUCCESS =
    "GET_MODEL_BY_ASSET_MAKES_SUCCESS";
export const FETCH_ASSET_REPORT_DATA_SUCCESS =
    "FETCH_ASSET_REPORT_DATA_SUCCESS";
export const FETCH_ASSET_HISTORY_REPORT_DATA_SUCCESS =
    "FETCH_ASSET_HISTORY_REPORT_DATA_SUCCESS";
export const CLEAR_ASSET_DATA = "CLEAR_ASSET_DATA";
export const CLEAR_ASSET_FOR_LABEL_DATA = "CLEAR_ASSET_FOR_LABEL_DATA";
export const CLEAR_ASSET_MODEL_DATA = "CLEAR_ASSET_MODEL_DATA";
export const FETCH_BOWSER_DATA_SUCCESS = "FETCH_BOWSER_DATA_SUCCESS";
export const FETCH_FUEL_STATUS_DATE_SUCCESS = "FETCH_FUEL_STATUS_DATE_SUCCESS";
export const MAKE_ASSET_LEASABLE = "MAKE_ASSET_LEASABLE";
export const GET_ALL_ASSETS_SUCCESS = "GET_ALL_ASSETS_SUCCESS";
export const GET_ALL_ASSETS_START = "GET_ALL_ASSETS_START";
export const FETCH_GLOBAL_SEARCH_START = "FETCH_GLOBAL_SEARCH_START";
export const FETCH_GLOBAL_SEARCH_END = "FETCH_GLOBAL_SEARCH_END";
;
export const FETCH_GLOBAL_ASSET_SEARCH_START = "FETCH_GLOBAL_ASSET_SEARCH_START";
export const FETCH_GLOBAL_ASSET_SEARCH_END = "FETCH_GLOBAL_ASSET_SEARCH_END";
export const GET_ASSET_PARAMETER_SEARCH_SUCCESS = "GET_ASSET_PARAMETER_SEARCH_SUCCESS";
export const GET_GLOBAL_PARAMETER_SEARCH_SUCCESS = "GET_GLOBAL_PARAMETER_SEARCH_SUCCESS";
export const GET_GLOBAL_ASSET_SEARCH_SUCCESS = "GET_GLOBAL_ASSET_SEARCH_SUCCESS";
export const GET_APPLICATION_MODULE_SUCCESS = "GET_APPLICATION_MODULE_SUCCESS";
export const FETCH_ASSET_FILTERS_SUCCESS = "FETCH_ASSET_FILTERS_SUCCESS";

//Asset Type
export const GET_ASSET_TYPE_SUCCESS = "GET_ASSET_TYPE_SUCCESS";
export const CREATE_ASSET_TYPE_SUCCESS = "CREATE_ASSET_TYPE_SUCCESS";
export const FETCH_ASSET_TYPE_SUCCESS = "FETCH_ASSET_TYPE_SUCCESS";
export const SAVE_ASSET_TYPE_QUERY = "SAVE_ASSET_TYPE_QUERY";

//Asset Model
export const GET_EQUIPMENT_SUB_TYPE_SUCCESS = "GET_EQUIPMENT_SUB_TYPE_SUCCESS";
export const CREATE_EQUIPMENT_SUB_TYPE_SUCCESS =
    "CREATE_EQUIPMENT_SUB_TYPE_SUCCESS";
export const FETCH_EQUIPMENT_SUB_TYPE_SUCCESS =
    "FETCH_EQUIPMENT_SUB_TYPE_SUCCESS";
export const SAVE_EQUIPMENT_SUB_TYPE_QUERY = "SAVE_EQUIPMENT_SUB_TYPE_QUERY";
export const REFRESH_EQUIPMENT_SUB_TYPE_DATA =
    "REFRESH_EQUIPMENT_SUB_TYPE_DATA";

//Vendor
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const CREATE_VENDOR_SUCCESS = "CREATE_VENDOR_SUCCESS";
export const FETCH_VENDOR_SUCCESS = "FETCH_VENDOR_SUCCESS";
export const SAVE_VENDOR_QUERY = "SAVE_VENDOR_QUERY";

//Document
export const GET_DOCUMENT_SUCCESS = "GET_DOCUMENT_SUCCESS";
export const CREATE_DOCUMENT_SUCCESS = "CREATE_DOCUMENT_SUCCESS";
export const FETCH_DOCUMENT_SUCCESS = "FETCH_DOCUMENT_SUCCESS";
export const SAVE_DOCUMENT_QUERY = "SAVE_DOCUMENT_QUERY";
export const FETCH_ASSET_CODE_SUCCESS = "FETCH_ASSET_CODE_SUCCESS";
export const FETCH_DOCUMENT_TYPE_REPORT_SUCCESS =
    "FETCH_DOCUMENT_TYPE_REPORT_SUCCESS";
export const FETCH_DOCUMENT_ASSET_REPORT_DATA_SUCCESS =
    "FETCH_DOCUMENT_ASSET_REPORT_DATA_SUCCESS";
export const CLEAR_DOCUMENT_PROPS_SUCCESS = "CLEAR_DOCUMENT_PROPS_SUCCESS";
export const CREATE_SUSPEND_DOCUMENT_SUCCESS =
    "CREATE_SUSPEND_DOCUMENT_SUCCESS";

//Document Type
export const GET_DOCUMENT_TYPE_SUCCESS = "GET_DOCUMENT_TYPE_SUCCESS";
export const CREATE_DOCUMENT_TYPE_SUCCESS = "CREATE_DOCUMENT_TYPE_SUCCESS";
export const FETCH_DOCUMENT_TYPE_SUCCESS = "FETCH_DOCUMENT_TYPE_SUCCESS";
export const SAVE_DOCUMENT_TYPE_QUERY = "SAVE_DOCUMENT_TYPE_QUERY";

//Document Renewal
export const GET_DOCUMENT_RENEWAL_SUCCESS = "GET_DOCUMENT_RENEWAL_SUCCESS";
export const CREATE_DOCUMENT_RENEWAL_SUCCESS = "CREATE_DOCUMENT_RENEWAL_SUCCESS";
export const SAVE_DOCUMENT_RENEWAL_QUERY = "SAVE_DOCUMENT_RENEWAL_QUERY";
export const FETCH_DOCUMENT_RENEWAL_SUCCESS = "FETCH_DOCUMENT_RENEWAL_SUCCESS";
//Manpower Reminder
export const GET_MANPOWER_REMINDER_SUCCESS = "GET_MANPOWER_REMINDER_SUCCESS";
export const CREATE_MANPOWER_REMINDER_SUCCESS = "CREATE_MANPOWER_REMINDER_SUCCESS";
export const SAVE_MANPOWER_REMINDER_QUERY = "SAVE_MANPOWER_REMINDER_QUERY";
export const FETCH_MANPOWER_REMINDER_SUCCESS = "FETCH_MANPOWER_REMINDER_SUCCESS";

export const GET_MANUAL_ASSET_READING_SUCCESS = "GET_MANUAL_ASSET_READING_SUCCESS";
export const CREATE_MANUAL_ASSET_READING_SUCCESS = "CREATE_MANUAL_ASSET_READING_SUCCESS";
export const SAVE_MANUAL_ASSET_READING_QUERY = "SAVE_MANUAL_ASSET_READING_QUERY";
export const FETCH_MANUAL_ASSET_READING_SUCCESS = "FETCH_MANUAL_ASSET_READING_SUCCESS";
export const FETCH_MANUAL_ASSET_LAST_READING_SUCCESS = "FETCH_MANUAL_ASSET_LAST_READING_SUCCESS";
export const FETCH_MANUAL_ASSET_LAST_READING_WITH_TIME_SUCCESS = "FETCH_MANUAL_ASSET_LAST_READING_WITH_TIME_SUCCESS";

//ASSET_READING
export const GET_ASSET_READING_SUCCESS = "GET_ASSET_READING_SUCCESS";
export const CREATE_ASSET_READING_SUCCESS = "CREATE_ASSET_READING_SUCCESS";
export const SAVE_ASSET_READING_QUERY = "SAVE_ASSET_READING_QUERY";
export const FETCH_ASSET_READING_SUCCESS = "FETCH_ASSET_READING_SUCCESS";
export const FETCH_ASSET_LAST_READING_SUCCESS = "FETCH_ASSET_LAST_READING_SUCCESS";
export const FETCH_ASSET_LAST_READING_WITH_TIME_SUCCESS = "FETCH_ASSET_LAST_READING_WITH_TIME_SUCCESS";
export const FETCH_ASSET_VERIFICATION_READING_RECORD_SUCCESS = "FETCH_ASSET_VERIFICATION_READING_RECORD_SUCCESS";

// Manpower
export const GET_MANPOWER_SUCCESS = " GET_MANPOWER_SUCCESS";
export const FETCH_MANPOWER_SUCCESS = "FETCH_MANPOWER_SUCCESS";
export const CREATE_MANPOWER_SUCCESS = "CREATE_MANPOWER_SUCCESS";
export const SAVE_MANPOWER_QUERY = "SAVE_MANPOWER_QUERY";

// Spare Part Type
export const GET_SPARE_PART_TYPE_SUCCESS = " GET_SPARE_PART_TYPE_SUCCESS";
export const FETCH_SPARE_PART_TYPE_SUCCESS = "FETCH_SPARE_PART_TYPE_SUCCESS";
export const CREATE_SPARE_PART_TYPE_SUCCESS = "CREATE_SPARE_PART_TYPE_SUCCESS";
export const SAVE_SPARE_PART_TYPE_QUERY = "SAVE_SPARE_PART_TYPE_QUERY";

// Spare Part
export const GET_SPARE_PART_SUCCESS = " GET_SPARE_PART_SUCCESS";
export const FETCH_SPARE_PART_SUCCESS = "FETCH_SPARE_PART_SUCCESS";
export const CREATE_SPARE_PART_SUCCESS = "CREATE_SPARE_PART_SUCCESS";
export const SAVE_SPARE_PART_QUERY = "SAVE_SPARE_PART_QUERY";
export const GET_ALL_SPARES_SUCCESS = "GET_ALL_SPARES_SUCCESS";
export const GET_ALL_SPARES_START = "GET_ALL_SPARES_START";
export const ADD_TO_MERGE_LIST = 'ADD_TO_MERGE_LIST_SUCCESS';
export const SPARE_MERGE_SUCCESS = 'SPARE_MERGE_SUCCESS';
export const SPARE_MERGE_FAILED = 'SPARE_MERGE_FAILED';
export const SPARE_NAME_GENERATE_SUCCESS = 'SPARE_NAME_GENERATE_SUCCESS';
export const SPARE_NAME_GENERATE_CLEAR = 'SPARE_NAME_GENERATE_CLEAR';
export const GET_SPARE_COMPATIBLE_SUCCESS = 'GET_SPARE_COMPATIBLE_SUCCESS';
export const GET_SPARE_FOR_SUBASSEMBLY_SUCCESS = 'GET_SPARE_FOR_SUBASSEMBLY_SUCCESS';


// Job Card
export const GET_JOB_CARD_SUCCESS = " GET_JOB_CARD_SUCCESS";
export const FETCH_JOB_CARD_SUCCESS = "FETCH_JOB_CARD_SUCCESS";
export const CREATE_JOB_CARD_SUCCESS = "CREATE_JOB_CARD_SUCCESS";
export const SAVE_JOB_CARD_QUERY = "SAVE_JOB_CARD_QUERY";
export const GET_JOB_CARD_FROM_JOB_ALLOCATION =
    "GET_JOB_CARD_FROM_JOB_ALLOCATION";
export const GET_MANPOWER_FROM_JOB_ALLOCATION =
    "GET_MANPOWER_FROM_JOB_ALLOCATION";
export const GET_LOCATION_BY_QUERY = "GET_LOCATION_BY_QUERY";
export const GET_COMPLAINT_DATA_SUCCESS = "GET_COMPLAINT_DATA_SUCCESS";
export const FETCH_JOB_CARD_REPORT_SUCCESS = "FETCH_JOB_CARD_REPORT_SUCCESS";
export const FETCH_JOB_CARD_COSTING_REPORT_SUCCESS = "FETCH_JOB_CARD_COSTING_REPORT_SUCCESS";
export const UNMOUNT_JOB_CARD = "UNMOUNT_JOB_CARD";
export const GET_ALL_JOBS_SUCCESS = "GET_ALL_JOBS_SUCCESS";
export const GET_ALL_JOBS_START = "GET_ALL_JOBS_START";
export const GET_ALL_OPEN_JOBS_SUCCESS = "GET_ALL_OPEN_JOBS_SUCCESS";
export const FETCH_JOB_CARD_SEARCH_SUCCESS = 'FETCH_JOB_CARD_SEARCH_SUCCESS';

// Iot Job Card
export const GET_IOT_JOB_CARD_SUCCESS = "GET_IOT_JOB_CARD_SUCCESS";
export const SAVE_IOT_JOB_CARD_QUERY = "SAVE_IOT_JOB_CARD_QUERY";

// Job Card Allocation
export const GET_JOB_CARD_ALLOCATION_SUCCESS =
    " GET_JOB_CARD_ALLOCATION_SUCCESS";
export const FETCH_JOB_CARD_ALLOCATION_SUCCESS =
    "FETCH_JOB_ALLOCATION_CARD_SUCCESS";
export const CREATE_JOB_CARD_ALLOCATION_SUCCESS =
    "CREATE_JOB_ALLOCATION_CARD_SUCCESS";
export const SAVE_JOB_CARD_ALLOCATION_QUERY = "SAVE_JOB_CARD_ALLOCATION_QUERY";
export const GET_LOCATION_BY_QUERY_IN_JOB_CARD_ALLOCATION =
    "GET_LOCATION_BY_QUERY_IN_JOB_CARD_ALLOCATION";

// Job Card Status Update
export const GET_JOB_CARD_STATUS_UPDATE_SUCCESS =
    " GET_JOB_CARD_STATUS_UPDATE_SUCCESS";
export const FETCH_JOB_CARD_STATUS_UPDATE_SUCCESS =
    "FETCH_JOB_CARD_STATUS_UPDATE_SUCCESS";
export const CREATE_JOB_CARD_STATUS_UPDATE_SUCCESS =
    "CREATE_JOB_CARD_STATUS_UPDATE_SUCCESS";
export const SAVE_JOB_CARD_STATUS_UPDATE_QUERY =
    "SAVE_JOB_CARD_STATUS_UPDATE_QUERY";

// Job Card Status Update
export const GET_JOB_CARD_STATUS_SUCCESS = " GET_JOB_CARD_STATUS_SUCCESS";
export const FETCH_JOB_CARD_STATUS_SUCCESS = "FETCH_JOB_CARD_STATUS_SUCCESS";
export const CREATE_JOB_CARD_STATUS_SUCCESS = "CREATE_JOB_CARD_STATUS_SUCCESS";
export const SAVE_JOB_CARD_STATUS_QUERY = "SAVE_JOB_CARD_STATUS_QUERY";

// Job Card Closure
export const GET_JOB_CARD_CLOSURE_SUCCESS = " GET_JOB_CARD_CLOSURE_SUCCESS";
export const FETCH_JOB_CARD_CLOSURE_SUCCESS = "FETCH_JOB_CARD_CLOSURE_SUCCESS";
export const CREATE_JOB_CARD_CLOSURE_SUCCESS =
    "CREATE_JOB_CARD_CLOSURE_SUCCESS";
export const SAVE_JOB_CARD_CLOSURE_QUERY = "SAVE_JOB_CARD_CLOSURE_QUERY";

// Asset Transfer Advice
export const GET_ASSET_TRANSFER_ADVICE_SUCCESS =
    " GET_ASSET_TRANSFER_ADVICE_SUCCESS";
export const FETCH_ASSET_TRANSFER_ADVICE_SUCCESS =
    "FETCH_ASSET_TRANSFER_ADVICE_SUCCESS";
export const CREATE_ASSET_TRANSFER_ADVICE_SUCCESS =
    "CREATE_ASSET_TRANSFER_ADVICE_SUCCESS";
export const SAVE_ASSET_TRANSFER_ADVICE_QUERY =
    "SAVE_ASSET_TRANSFER_ADVICE_QUERY";
export const FETCH_ASSETS_BY_QUERY_SUCCESS = "FETCH_ASSETS_BY_QUERY_SUCCESS";
export const FETCH_ATA_NO_SUCCESS = "FETCH_ATA_NO_SUCCESS";
export const FETCH_METER_UNIT_SUCCESS = "FETCH_METER_UNIT_SUCCESS";
export const CLEAR_ATA_PROPS = "CLEAR_ATA_PROPS";
export const FETCH_ALL_METER_UNIT_SUCCESS = "FETCH_ALL_METER_UNIT_SUCCESS";

// Asset Service
export const GET_ASSET_SERVICE_SUCCESS = " GET_ASSET_SERVICE_SUCCESS";
export const FETCH_ASSET_SERVICE_SUCCESS = "FETCH_ASSET_SERVICE_SUCCESS";
export const CREATE_ASSET_SERVICE_SUCCESS = "CREATE_ASSET_SERVICE_SUCCESS";
export const SAVE_ASSET_SERVICE_QUERY = "SAVE_ASSET_SERVICE_QUERY";
export const GET_COMPLAINT_BY_ASSET_SUCCESS = "GET_COMPLAINT_BY_ASSET_SUCCESS";
export const CREATE_COMPLAINT_BY_ASSET_SERVICE_SUCCESS =
    "CREATE_COMPLAINT_BY_ASSET_SERVICE_SUCCESS";
export const GET_EQUIPMENT_SUB_TYPE_DATA_SUCCESS =
    "GET_EQUIPMENT_SUB_TYPE_DATA_SUCCESS";

// Asset Receipt Note
export const GET_ASSET_RECEIPT_NOTE_SUCCESS = " GET_ASSET_RECEIPT_NOTE_SUCCESS";
export const FETCH_ASSET_RECEIPT_NOTE_SUCCESS =
    "FETCH_ASSET_RECEIPT_NOTE_SUCCESS";
export const CREATE_ASSET_RECEIPT_NOTE_SUCCESS =
    "CREATE_ASSET_RECEIPT_NOTE_SUCCESS";
export const SAVE_ASSET_RECEIPT_NOTE_QUERY = "SAVE_ASSET_RECEIPT_NOTE_QUERY";
export const FETCH_ASSET_LIST_BY_ATA = "FETCH_ASSET_LIST_BY_ATA";
export const FETCH_ARN_NO_SUCCESS = "FETCH_ARN_NO_SUCCESS";
export const CANCEL_ATA_SUCCESS = "CANCEL_ATA_SUCCESS";
export const CLEAR_ARN_DATA_SUCCESS = "CLEAR_ARN_DATA_SUCCESS";
export const FETCH_METER_UNIT_SUCCESS_ARN = "FETCH_METER_UNIT_SUCCESS_ARN";
export const FETCH_OPEN_STA_SUCCESS = "FETCH_OPEN_STA_SUCCESS";

// Purchase Order
export const GET_PURCHASE_ORDER_SUCCESS = "GET_PURCHASE_ORDER_SUCCESS";
export const CREATE_PURCHASE_ORDER_SUCCESS = "CREATE_PURCHASE_ORDER_SUCCESS";
export const FETCH_PURCHASE_ORDER_SUCCESS = "FETCH_PURCHASE_ORDER_SUCCESS";
export const SAVE_PURCHASE_ORDER_QUERY = "SAVE_PURCHASE_ORDER_QUERY";
export const GET_ALL_UOM_IN_PO_SUCCESS = "GET_ALL_UOM_IN_PO_SUCCESS";
export const UNMOUNT_PURCHASE_ORDER_SUCCESS = "UNMOUNT_PURCHASE_ORDER_SUCCESS";
export const GET_GLOBAL_PARAMETER_PO_SEARCH_SUCCESS = 'GET_GLOBAL_PARAMETER_PO_SEARCH_SUCCESS';
export const GET_ASSET_PURCHASE_REPORT_SUCCESS = 'GET_ASSET_PURCHASE_REPORT_SUCCESS';
// Sale Order
export const GET_SALE_ORDER_SUCCESS = "GET_SALE_ORDER_SUCCESS";
export const CREATE_SALE_ORDER_SUCCESS = "CREATE_SALE_ORDER_SUCCESS";
export const FETCH_SALE_ORDER_SUCCESS = "FETCH_SALE_ORDER_SUCCESS";
export const SAVE_SALE_ORDER_QUERY = "SAVE_SALE_ORDER_QUERY";
export const FETCH_ASSETS_BY_LOCATION_SUCCESS =
    "FETCH_ASSETS_BY_LOCATION_SUCCESS";
export const FETCH_EQUIPMENT_SUB_TYPE_BY_ASSET_SUCCESS =
    "FETCH_EQUIPMENT_SUB_TYPE_BY_ASSET_SUCCESS";
export const UNMOUNT_SALE_ORDER_SUCCESS = "UNMOUNT_SALE_ORDER_SUCCESS";

// Sub Asset Transfer
export const GET_SUB_ASSET_TRANSFER_SUCCESS = " GET_SUB_ASSET_TRANSFER_SUCCESS";
export const FETCH_SUB_ASSET_TRANSFER_SUCCESS =
    "FETCH_SUB_ASSET_TRANSFER_SUCCESS";
export const CREATE_SUB_ASSET_TRANSFER_SUCCESS =
    "CREATE_SUB_ASSET_TRANSFER_SUCCESS";
export const SAVE_SUB_ASSET_TRANSFER_QUERY = "SAVE_SUB_ASSET_TRANSFER_QUERY";
export const FETCH_CHILD_ASSET_BY_ID_SUCCESS =
    "FETCH_CHILD_ASSET_BY_ID_SUCCESS";
export const FETCH_ASSET_WITH_PARENT_KEY_SUCCESS =
    "FETCH_ASSET_WITH_PARENT_KEY_SUCCESS";
export const CLEAR_PROPS_DATA = "CLEAR_PROPS_DATA";
export const GET_JOB_CARD_FROM_ASSET = "GET_JOB_CARD_FROM_ASSET";
export const GET_JOB_CARD_FROM_ASSET_START = "GET_JOB_CARD_FROM_ASSET_START";
export const GET_JOB_CARD_FROM_ASSET_STOP = "GET_JOB_CARD_FROM_ASSET_STOP";

// Owner
export const GET_OWNER_SUCCESS = " GET_OWNER_SUCCESS";
export const FETCH_OWNER_SUCCESS = "FETCH_OWNER_SUCCESS";
export const CREATE_OWNER_SUCCESS = "CREATE_OWNER_SUCCESS";
export const SAVE_OWNER_QUERY = "SAVE_OWNER_QUERY";

// Organisation Type
export const GET_ORGANISATION_TYPE_SUCCESS = " GET_ORGANISATION_TYPE_SUCCESS";
export const FETCH_ORGANISATION_TYPE_SUCCESS = "FETCH_ORGANISATION_TYPE_SUCCESS";
export const CREATE_ORGANISATION_TYPE_SUCCESS = "CREATE_ORGANISATION_TYPE_SUCCESS";
export const SAVE_ORGANISATION_TYPE_QUERY = "SAVE_ORGANISATION_TYPE_QUERY";

// Job Type
export const GET_JOB_TYPE_SUCCESS = " GET_JOB_TYPE_SUCCESS";
export const FETCH_JOB_TYPE_SUCCESS = "FETCH_JOB_TYPE_SUCCESS";
export const CREATE_JOB_TYPE_SUCCESS = "CREATE_JOB_TYPE_SUCCESS";
export const SAVE_JOB_TYPE_QUERY = "SAVE_JOB_TYPE_QUERY";

//Labour
export const GET_LABOUR_SUCCESS = "GET_LABOUR_SUCCESS";
export const FETCH_LABOUR_SUCCESS = "FETCH_LABOUR_SUCCESS";
export const CREATE_LABOUR_SUCCESS = "CREATE_LABOUR_SUCCESS";
export const SAVE_LABOUR_QUERY = "SAVE_LABOUR_QUERY";

//ThirdPartyWorkRequirement
export const GET_TPW_SUCCESS = "GET_TPW_SUCCESS";
export const FETCH_TPW_SUCCESS = "FETCH_TPW_SUCCESS";
export const CREATE_TPW_SUCCESS = "CREATE_TPW_SUCCESS";
export const SAVE_TPW_QUERY = "SAVE_TPW_QUERY";
export const FETCH_ACTIVITY_SNO_SUCCESS = "FETCH_ACTIVITY_SNO";

//ActivityClosure
export const CREATE_AC_SUCCESS = "CREATE_TPW_SUCCESS";
export const FETCH_ACTIVITY_SNO_SUCCESS_FOR_ACTIVITY_CLOSURE =
    "FETCH_ACTIVITY_SNO_SUCCESS_FOR_ACTIVITY_CLOSURE";

//ThirdPartyWorkQuotation
export const GET_TPWQ_SUCCESS = "GET_TPWQ_SUCCESS";
export const FETCH_TPWQ_SUCCESS = "FETCH_TPWQ_SUCCESS";
export const CREATE_TPWQ_SUCCESS = "CREATE_TPWQ_SUCCESS";
export const SAVE_TPWQ_QUERY = "SAVE_TPWQ_QUERY";
export const FETCH_TPW_NO_SUCCESS = "FETCH_TPW_NO_SUCCESS";
export const STORE_TOTAL_DATA_FOR_SPARE = "STORE_TOTAL_DATA_FOR_SPARE";
export const STORE_TOTAL_DATA_FOR_LABOUR = "STORE_TOTAL_DATA_FOR_LABOUR";
export const CLEAR_PROPS_FOR_QUOTATION = "CLEAR_PROPS_FOR_QUOTATION";

//ThirdPartyWorkApproval
export const CREATE_TPWA_SUCCESS = "CREATE_TPWA_SUCCESS";
export const SAVE_TPWA_QUERY = "SAVE_TPWA_QUERY";
export const FETCH_QUOTATIONS_SUCCESS = "FETCH_QUOTATIONS_SUCCESS";
export const CLEAR_PROPS_SUCCESS = "CLEAR_PROPS_SUCCESS";
export const FETCH_TPW_SNO_SUCCESS = "FETCH_TPW_NO_SUCCESS";

//ThirdPartyWorkOrderUpdate
export const CREATE_TPWOU_SUCCESS = "CREATE_TPWOU_SUCCESS";
export const FETCH_QUOTATION_SUCCESS = "FETCH_QUOTATION_SUCCESS";
export const FIND_TPW_SNO_SUCCESS = "FIND_TPW_NO_SUCCESS";
export const CLEAR_PROPS_DATA_SUCCESS = "CLEAR_PROPS_DATA_SUCCESS";

//InvoiceEntry
export const SAVE_INVOICE_ENTRY_QUERY = "SAVE_INVOICE_ENTRY_QUERY";
export const FETCH_INVOICE_ENTRY_SUCCESS = "FETCH_INVOICE_ENTRY_SUCCESS";
export const GET_INVOICE_ENTRY_SUCCESS = "GET_INVOICE_ENTRY_SUCCESS";
export const CREATE_INVOICE_ENTRY_SUCCESS = "CREATE_INVOICE_ENTRY_SUCCESS";
export const FETCH_QUOTE_SUCCESS = "FETCH_QUOTE_SUCCESS";
export const FIND_TPW_SUCCESS = "FIND_TPW_SUCCESS";
export const CLEAR_PROP_SUCCESS = "CLEAR_PROP_SUCCESS";
export const FETCH_ACTIVITY_NO_SUCCESS = "FETCH_ACTIVITY_NO";
export const STORE_TOTAL_DATA_FOR_LABOUR_INVOICE =
    "STORE_TOTAL_DATA_FOR_LABOUR_INVOICE";
export const STORE_TOTAL_DATA_FOR_SPARE_INVOICE =
    "STORE_TOTAL_DATA_FOR_SPARE_INVOICE";
export const STORE_TOTAL_DATA_FOR_INVOICE = "STORE_TOTAL_DATA_FOR_INVOICE";
export const FETCH_FORM_DATA_SUCCESS = "FETCH_FORM_DATA_SUCCESS";

// Manpower Performance
export const GET_MANPOWER_PERFORMANCE_SUCCESS =
    " GET_MANPOWER_PERFORMANCE_SUCCESS";
export const FETCH_MANPOWER_PERFORMANCE_SUCCESS =
    "FETCH_MANPOWER_PERFORMANCE_SUCCESS";
export const CREATE_MANPOWER_PERFORMANCE_SUCCESS =
    "CREATE_MANPOWER_PERFORMANCE_SUCCESS";
export const SAVE_MANPOWER_PERFORMANCE_QUERY =
    "SAVE_MANPOWER_PERFORMANCE_QUERY";
export const GET_JOB_CARD_BY_LOCATION_SUCCESS =
    "GET_JOB_CARD_BY_LOCATION_SUCCESS";
export const CLEAR_MANPOWER_PERFORMANCE_SUCCESS =
    "CLEAR_MANPOWER_PERFORMANCE_SUCCESS";
export const GET_JOB_CARD_STATUS_BY_ACTIVITY_ID =
    "GET_JOB_CARD_STATUS_BY_ACTIVITY_ID";
export const FETCH_MANPOWER_PERFORMANCE_REPORT_DATA_SUCCESS =
    "FETCH_MANPOWER_PERFORMANCE_REPORT_DATA_SUCCESS";
export const CLEAR_MANPOWER_PERFORMANCE_REPORT_DATA =
    "CLEAR_MANPOWER_PERFORMANCE_REPORT_DATA";

//Manpower Attendance
export const FETCH_MANPOWER_ATTENDANCE_REPORT_DATA_SUCCESS =
    "FETCH_MANPOWER_ATTENDANCE_REPORT_DATA_SUCCESS";
export const CLEAR_MANPOWER_ATTENDANCE_REPORT_DATA =
    "CLEAR_MANPOWER_ATTENDANCE_REPORT_DATA";

// Interval
export const GET_INTERVAL_SUCCESS = " GET_INTERVAL_SUCCESS";
export const FETCH_INTERVAL_SUCCESS = "FETCH_INTERVAL_SUCCESS";
export const CREATE_INTERVAL_SUCCESS = "CREATE_INTERVAL_SUCCESS";
export const SAVE_INTERVAL_QUERY = "SAVE_INTERVAL_QUERY";

// Meter
export const GET_METER_SUCCESS = " GET_METER_SUCCESS";
export const FETCH_METER_SUCCESS = "FETCH_METER_SUCCESS";
export const CREATE_METER_SUCCESS = "CREATE_METER_SUCCESS";
export const SAVE_METER_QUERY = "SAVE_METER_QUERY";
export const FETCH_ASSET_METER_DETAIL_SUCCESS = "FETCH_ASSET_METER_DETAIL_SUCCESS";

// Asset Refurbished
export const GET_ASSET_REFURBISHED_SUCCESS = " GET_ASSET_REFURBISHED_SUCCESS";
export const FETCH_ASSET_REFURBISHED_SUCCESS =
    "FETCH_ASSET_REFURBISHED_SUCCESS";
export const CREATE_ASSET_REFURBISHED_SUCCESS =
    "CREATE_ASSET_REFURBISHED_SUCCESS";
export const SAVE_ASSET_REFURBISHED_QUERY = "SAVE_ASSET_REFURBISHED_QUERY";

// Unit Of Measurement
export const GET_UNIT_OF_MEASUREMENT_SUCCESS =
    " GET_UNIT_OF_MEASUREMENT_SUCCESS";
export const FETCH_UNIT_OF_MEASUREMENT_SUCCESS =
    "FETCH_UNIT_OF_MEASUREMENT_SUCCESS";
export const CREATE_UNIT_OF_MEASUREMENT_SUCCESS =
    "CREATE_UNIT_OF_MEASUREMENT_SUCCESS";
export const SAVE_UNIT_OF_MEASUREMENT_QUERY = "SAVE_UNIT_OF_MEASUREMENT_QUERY";

// Spare part attribute
export const GET_SPARE_PART_ATTRIBUTE_SUCCESS =
    " GET_SPARE_PART_ATTRIBUTE_SUCCESS";
export const FETCH_SPARE_PART_ATTRIBUTE_SUCCESS =
    "FETCH_SPARE_PART_ATTRIBUTE_SUCCESS";
export const CREATE_SPARE_PART_ATTRIBUTE_SUCCESS =
    "CREATE_SPARE_PART_ATTRIBUTE_SUCCESS";
export const SAVE_SPARE_PART_ATTRIBUTE_QUERY = "SAVE_SPARE_PART_ATTRIBUTE_QUERY";

// Sub assembly
export const GET_SUB_ASSEMBLY_SUCCESS =
    " GET_SUB_ASSEMBLY_SUCCESS";
export const FETCH_SUB_ASSEMBLY_SUCCESS =
    "FETCH_SUB_ASSEMBLY_SUCCESS";
export const CREATE_SUB_ASSEMBLY_SUCCESS =
    "CREATE_SUB_ASSEMBLY_SUCCESS";
export const SAVE_SUB_ASSEMBLY_QUERY = "SAVE_SUB_ASSEMBLY_QUERY";

// Spare Part Transaction
export const GET_SPARE_PART_TRANSACTION_SUCCESS =
    " GET_SPARE_PART_TRANSACTION_SUCCESS";
export const FETCH_SPARE_PART_TRANSACTION_SUCCESS =
    "FETCH_SPARE_PART_TRANSACTION_SUCCESS";
export const CREATE_SPARE_PART_TRANSACTION_SUCCESS =
    "CREATE_SPARE_PART_TRANSACTION_SUCCESS";
export const SAVE_SPARE_PART_TRANSACTION_QUERY =
    "SAVE_SPARE_PART_TRANSACTION_QUERY";
export const GET_QUANTITY_BY_SUB_LOCATION = "GET_QUANTITY_BY_SUB_LOCATION";

// Spare Transfer Advice
export const GET_SPARE_TRANSFER_ADVICE_SUCCESS =
    " GET_SPARE_TRANSFER_ADVICE_SUCCESS";
export const FETCH_SPARE_TRANSFER_ADVICE_SUCCESS =
    "FETCH_SPARE_TRANSFER_ADVICE_SUCCESS";
export const CREATE_SPARE_TRANSFER_ADVICE_SUCCESS =
    "CREATE_SPARE_TRANSFER_ADVICE_SUCCESS";
export const SAVE_SPARE_TRANSFER_ADVICE_QUERY =
    "SAVE_SPARE_TRANSFER_ADVICE_QUERY";
export const FETCH_SPARE_PARTS_BY_QUERY_SUCCESS =
    "FETCH_SPARE_PARTS_BY_QUERY_SUCCESS";

// Spare Receipt Advise
export const GET_SPARE_RECEIPT_ADVISE_SUCCESS =
    " GET_SPARE_RECEIPT_ADVISE_SUCCESS";
export const FETCH_SPARE_RECEIPT_ADVISE_SUCCESS =
    "FETCH_SPARE_RECEIPT_ADVISE_SUCCESS";
export const CREATE_SPARE_RECEIPT_ADVISE_SUCCESS =
    "CREATE_SPARE_RECEIPT_ADVISE_SUCCESS";
export const SAVE_SPARE_RECEIPT_ADVISE_QUERY =
    "SAVE_SPARE_RECEIPT_ADVISE_QUERY";
export const FETCH_ASSET_LIST_BY_STA = "FETCH_ASSET_LIST_BY_STA";
export const FETCH_SRA_NO_SUCCESS = "FETCH_SRA_NO_SUCCESS";

// Complaint
export const GET_COMPLAINT_SUCCESS = " GET_COMPLAINT_SUCCESS";
export const FETCH_COMPLAINT_SUCCESS = "FETCH_COMPLAINT_SUCCESS";
export const CREATE_COMPLAINT_SUCCESS = "CREATE_COMPLAINT_SUCCESS";
export const SAVE_COMPLAINT_QUERY = "SAVE_COMPLAINT_QUERY";
export const FETCH_UNSERVIECABLE_REPORT_SUCCESS =
    "FETCH_UNSERVICEABLE_REPORT_SUCCESS";
export const SAVE_COMPLAINT_REPORT_QUERY = "SAVE_COMPLAINT_REPORT_QUERY";
export const GET_US_ASSET_COUNT_SUCCESS = "GET_US_ASSET_COUNT_SUCCESS";
export const GET_US_ASSET_COUNT_START = "GET_US_ASSET_COUNT_START";
export const GET_OPEN_COUNT_SUCCESS = "GET_OPEN_COUNT_SUCCESS";
export const GET_OPEN_COUNT_START = "GET_OPEN_COUNT_START";

// Activity
export const GET_ACTIVITY_SUCCESS = " GET_ACTIVITY_SUCCESS";
export const FETCH_ACTIVITY_SUCCESS = "FETCH_ACTIVITY_SUCCESS";
export const CREATE_ACTIVITY_SUCCESS = "CREATE_ACTIVITY_SUCCESS";
export const SAVE_ACTIVITY_QUERY = "SAVE_ACTIVITY_QUERY";
export const FETCH_ACTIVITY_DETAILS_SUCCESS = "FETCH_ACTIVITY_DETAILS_SUCCESS";
export const GET_TRANSFERABLE_ACTIVITIES = "GET_TRANSFERABLE_ACTIVITIES";
export const FETCH_ACTIVITY_DETAILS_START = "FETCH_ACTIVITY_DETAILS_START";
export const FETCH_ACTIVITY_DETAILS_STOP = "FETCH_ACTIVITY_DETAILS_STOP";

// Activity Type
export const GET_ACTIVITY_TYPE_SUCCESS = " GET_ACTIVITY_TYPE_SUCCESS";
export const FETCH_ACTIVITY_TYPE_SUCCESS = "FETCH_ACTIVITY_TYPE_SUCCESS";
export const CREATE_ACTIVITY_TYPE_SUCCESS = "CREATE_ACTIVITY_TYPE_SUCCESS";
export const SAVE_ACTIVITY_TYPE_QUERY = "SAVE_ACTIVITY_TYPE_QUERY";

// Log
export const GET_LOG_SUCCESS = " GET_LOG_SUCCESS";
export const FETCH_LOG_SUCCESS = "FETCH_LOG_SUCCESS";
export const CREATE_LOG_SUCCESS = "CREATE_LOG_SUCCESS";
export const SAVE_LOG_QUERY = "SAVE_LOG_QUERY";

// Spares Issue
export const GET_SPARES_ISSUE_SUCCESS = " GET_SPARES_ISSUE_SUCCESS";
export const FETCH_SPARES_ISSUE_SUCCESS = "FETCH_SPARES_ISSUE_SUCCESS";
export const CREATE_SPARES_ISSUE_SUCCESS = "CREATE_SPARES_ISSUE_SUCCESS";
export const SAVE_SPARES_ISSUE_QUERY = "SAVE_SPARES_ISSUE_QUERY";
export const GET_LOCATION_IN_SPARES_ISSUE_SUCCESS =
    "GET_LOCATION_IN_SPARES_ISSUE_SUCCESS";
export const GET_JOB_CARD_IN_SPARES_ISSUE_SUCCESS =
    "GET_JOB_CARD_IN_SPARES_ISSUE_SUCCESS";
export const SAVE_SPARE_NAME_IN_SPARE_ISSUES =
    "SAVE_SPARE_NAME_IN_SPARE_ISSUES";
export const GET_ALL_UOM_SUCCESS = "GET_ALL_UOM_SUCCESS";

export const FETCH_RELATIONSHIP_SEARCH = " FETCH_RELATIONSHIP_SEARCH";
export const SAVE_RELATIONSHIP_SEARCH = "SAVE_RELATIONSHIP_SEARCH";
export const GET_ASSET_SPARE_ISSUE_REPORT_SUCCESS = 'GET_ASSET_SPARE_ISSUE_REPORT_SUCCESS';

// Status
export const GET_STATUS_SUCCESS = " GET_STATUS_SUCCESS";
export const FETCH_STATUS_SUCCESS = "FETCH_STATUS_SUCCESS";
export const CREATE_STATUS_SUCCESS = "CREATE_STATUS_SUCCESS";
export const SAVE_STATUS_QUERY = "SAVE_STATUS_QUERY";
export const GET_ALL_STATUS_SUCCESS = "GET_ALL_STATUS_SUCCESS";

// StockMethod
export const GET_STOCK_METHOD_SUCCESS = " GET_STOCK_METHOD_SUCCESS";
export const FETCH_STOCK_METHOD_SUCCESS = "FETCH_STOCK_METHOD_SUCCESS";
export const CREATE_STOCK_METHOD_SUCCESS = "CREATE_STOCK_METHOD_SUCCESS";
export const SAVE_STOCK_METHOD_QUERY = "SAVE_STOCK_METHOD_QUERY";
export const GET_ALL_STOCK_METHOD_SUCCESS = "GET_ALL_STOCK_METHOD_SUCCESS";

// Fuel Type
export const GET_FUEL_TYPE_SUCCESS = "GET_FUEL_TYPE_SUCCESS";
export const FETCH_FUEL_TYPE_SUCCESS = "FETCH_FUEL_TYPE_SUCCESS";
export const CREATE_FUEL_TYPE_SUCCESS = "CREATE_FUEL_TYPE_SUCCESS";
export const SAVE_FUEL_TYPE_QUERY = "SAVE_FUEL_TYPE_QUERY";

//FUEL_READING_METHOD
export const GET_FUEL_READING_METHOD_SUCCESS = "GET_FUEL_READING_METHOD_SUCCESS";
export const FETCH_FUEL_READING_METHOD_SUCCESS = "FETCH_FUEL_READING_METHOD_SUCCESS";
export const CREATE_FUEL_READING_METHOD_SUCCESS = "CREATE_FUEL_READING_METHOD_SUCCESS";
export const SAVE_FUEL_READING_METHOD_QUERY = "SAVE_FUEL_READING_METHOD_QUERY";

//FUEL_LEVEL_READING
export const GET_FUEL_LEVEL_READING_SUCCESS = "GET_FUEL_LEVEL_READING_SUCCESS";
export const FETCH_FUEL_LEVEL_READING_SUCCESS = "FETCH_FUEL_LEVEL_READING_SUCCESS";
export const CREATE_FUEL_LEVEL_READING_SUCCESS = "CREATE_FUEL_LEVEL_READING_SUCCESS";
export const SAVE_FUEL_LEVEL_READING_QUERY = "SAVE_FUEL_LEVEL_READING_QUERY";

//FLEET_TRIP
export const GET_FLEET_TRIP_SUCCESS = "GET_FLEET_TRIP_SUCCESS";
export const FETCH_FLEET_TRIP_SUCCESS = "FETCH_FLEET_TRIP_SUCCESS";
export const CREATE_FLEET_TRIP_SUCCESS = "CREATE_FLEET_TRIP_SUCCESS";
export const SAVE_FLEET_TRIP_QUERY = "SAVE_FLEET_TRIP_QUERY";

// Fuel Status
export const GET_FUEL_STATUS_SUCCESS = "GET_FUEL_STATUS_SUCCESS";
export const FETCH_FUEL_STATUS_SUCCESS = "FETCH_FUEL_STATUS_SUCCESS";
export const CREATE_FUEL_STATUS_SUCCESS = "CREATE_FUEL_STATUS_SUCCESS";
export const SAVE_FUEL_STATUS_QUERY = "SAVE_FUEL_STATUS_QUERY";

// Fuel
export const GET_FUEL_SUCCESS = "GET_FUEL_SUCCESS";
export const FETCH_FUEL_SUCCESS = "FETCH_FUEL_SUCCESS";
export const FETCH_ASSET_FUEL_SUCCESS = "FETCH_ASSET_FUEL_SUCCESS";
export const CREATE_FUEL_SUCCESS = "CREATE_FUEL_SUCCESS";
export const SAVE_FUEL_QUERY = "SAVE_FUEL_QUERY";
export const FETCH_FUEL_REPORT_DATA_SUCCESS = "FETCH_FUEL_REPORT_DATA_SUCCESS";
export const FETCH_FUEL_MILEAGE_REPORT_DATA_SUCCESS = "FETCH_FUEL_MILEAGE_REPORT_DATA_SUCCESS";
export const FETCH_FUEL_SUMMERY_REPORT_DATA_SUCCESS = "FETCH_FUEL_SUMMERY_REPORT_DATA_SUCCESS";
export const FETCH_FUEL_REFUEL_REPORT_DATA_SUCCESS = "FETCH_FUEL_REFUEL_REPORT_DATA_SUCCESS";
export const FETCH_FUEL_HISTORY_REPORT_DATA_SUCCESS =
    "FETCH_FUEL_HISTORY_REPORT_DATA_SUCCESS";
export const FETCH_BOWSER_TRANSACTION_REPORT_DATA_SUCCESS = "FETCH_BOWSER_TRANSACTION_REPORT_DATA_SUCCESS";
export const FETCH_BOWSER_REPORT_DATA_SUCCESS = "FETCH_BOWSER_REPORT_DATA_SUCCESS";
export const CLEAR_FUEL_REPORT_DATA = "CLEAR_FUEL_REPORT_DATA";
export const FETCH_ASSET_FILTER_SUCCESS = "FETCH_ASSET_FILTER_SUCCESS";
export const FETCH_MOTORABLE_ASSET_SUCCESS = "FETCH_MOTORABLE_ASSET_SUCCESS";
export const FETCH_FUEL_FILTER_DATA_SUCCESS = "FETCH_FUEL_FILTER_DATA_SUCCESS";

// Qr Scanned
export const GET_QR_SCAN_LOG_SUCCESS = "GET_QR_SCAN_LOG_SUCCESS";
export const FETCH_QR_SCAN_LOG_SUCCESS = "FETCH_QR_SCAN_LOG_SUCCESS";
export const CREATE_QR_SCAN_LOG_SUCCESS = "CREATE_QR_SCAN_LOG_SUCCESS";
export const SAVE_QR_SCAN_LOG_QUERY = "SAVE_QR_SCAN_LOG_QUERY";
export const CLEAR_QR_SCAN_LOG_QUERY = "CLEAR_QR_SCAN_LOG_QUERY";

// Condition of Asset
export const GET_CONDITION_OF_ASSET_SUCCESS = "GET_CONDITION_OF_ASSET_SUCCESS";
export const FETCH_CONDITION_OF_ASSET_SUCCESS =
    "FETCH_CONDITION_OF_ASSET_SUCCESS";
export const CREATE_CONDITION_OF_ASSET_SUCCESS =
    "CREATE_CONDITION_OF_ASSET_SUCCESS";
export const SAVE_CONDITION_OF_ASSET_QUERY = "SAVE_CONDITION_OF_ASSET_QUERY";

// Condition of Employee_Asset_Receipt
export const GET_EMPLOYEE_ASSET_RECEIPT_SUCCESS =
    "GET_EMPLOYEE_ASSET_RECEIPT_SUCCESS";
export const FETCH_EMPLOYEE_ASSET_RECEIPT_SUCCESS =
    "FETCH_EMPLOYEE_ASSET_RECEIPT_SUCCESS";
export const CREATE_EMPLOYEE_ASSET_RECEIPT_SUCCESS =
    "CREATE_EMPLOYEE_ASSET_RECEIPT_SUCCESS";
export const SAVE_EMPLOYEE_ASSET_RECEIPT_QUERY =
    "SAVE_CONDITION_OF_ASSET_QUERY";
export const FETCH_EAI_BY_EMPLOYEE_SUCCESS = "FETCH_EAI_BY_EMPLOYEE_SUCCESS";
export const CLEAR_EAR_DATA_SUCCESS = "CLEAR_EAR_DATA_SUCCESS";
export const FETCH_ASSETS_BY_EAI_SUCCESS = "FETCH_ASSETS_BY_EAI_SUCCESS";

// Asset Model
export const GET_ASSET_MODEL_SUCCESS = " GET_ASSET_MODEL_SUCCESS";
export const FETCH_ASSET_MODEL_SUCCESS = "FETCH_ASSET_MODEL_SUCCESS";
export const CREATE_ASSET_MODEL_SUCCESS = "CREATE_ASSET_MODEL_SUCCESS";
export const SAVE_ASSET_MODEL_QUERY = "SAVE_ASSET_MODEL_QUERY";

// MASTER
export const FETCH_MASTER_FILTER_SUCCESS = "FETCH_MASTER_FILTER_SUCCESS";
export const FETCH_SUB_MASTER_FILTER_SUCCESS = "FETCH_SUB_MASTER_FILTER_SUCCESS";

// Employee Asset Issue
export const GET_EMPLOYEE_ASSET_ISSUE_SUCCESS =
    "GET_EMPLOYEE_ASSET_ISSUE_SUCCESS";
export const FETCH_EMPLOYEE_ASSET_ISSUE_SUCCESS =
    "FETCH_EMPLOYEE_ASSET_ISSUE_SUCCESS";
export const CREATE_EMPLOYEE_ASSET_ISSUE_SUCCESS =
    "CREATE_EMPLOYEE_ASSET_ISSUE_SUCCESS";
export const SAVE_EMPLOYEE_ASSET_ISSUE_QUERY =
    "SAVE_EMPLOYEE_ASSET_ISSUE_QUERY";
export const FETCH_EMPLOYEE_ASSETS_BY_LOCATION_SUCCESS =
    "FETCH_EMPLOYEE_ASSETS_BY_LOCATION_SUCCESS";
export const CLEAR_EAI_DATA_SUCCESS = "CLEAR_EAI_DATA_SUCCESS";

// Spare part purchase history
export const FETCH_PO_FOR_TYPE_SUCESS = "FETCH_PO_FOR_TYPE_SUCCESS";
export const PO_FOR_TYPE_LOAD_MORE_SUCESS = "PO_FOR_TYPE_LOAD_MORE_SUCESS";
export const FETCH_PO_FOR_TYPE_FAIL = "FETCH_PO_FOR_TYPE_FAIL";

// Spare part inventory report
export const FETCH_SPARE_INVENTORY_SUCCESS = "FETCH_SPARE_INVENTORY_SUCCESS";
export const FETCH_SPARE_INVENTORY_FAIL = "FETCH_SPARE_INVENTORY_FAIL";
export const FETCH_SPARE_INVENTORY_FILTER = "FETCH_SPARE_INVENTORY_FILTER";
export const RESET_SPARE_INVENTORY = "RESET_SPARE_INVENTORY";
export const SPARE_PART_BALANCE_SUCCESS = "SPARE_PART_BALANCE_SUCCESS";

// Notification Setting
export const FETCH_NOTIFICATION_SETTING_SUCCESS =
    "FETCH_NOTIFICATION_SETTING_SUCCESS";

// Leasing
export const FETCH_LEASING_SUCCESS = "FETCH_LEASING_SUCCESS";
export const FETCH_LEASING_FAIL = "FETCH_LEASING_FAIL";
export const UPDATE_LEASING_DESCRIPTION_SUCCESS =
    "UPDATE_LEASING_DESCRIPTION_SUCCESS";
export const UPDATE_LEASING_DESCRIPTION_FAIL =
    "UPDATE_LEASING_DESCRIPTION_FAIL";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const REMOVE_IMAGE_SUCCESS = "REMOVE_IMAGE_SUCCESS";
export const FETCH_LEASING_STATUS_SUCCESS = "FETCH_LEASING_STATUS_SUCCESS";
export const FETCH_LEASING_STATUS_FAILED = "FETCH_LEASING_STATUS_FAILED";
export const FETCH_LEASING_STATUS_START = "FETCH_LEASING_STATUS_START";
export const FETCH_LEASING_COST_SUCCESS = "FETCH_LEASING_COST_SUCCESS";
export const FETCH_LEASING_COST_FAILED = "FETCH_LEASING_COST_FAILED";
export const FETCH_LEASING_COST_START = "FETCH_LEASING_COST_START";
export const FETCH_LEASING_REVENUE_SUCCESS = "FETCH_LEASING_REVENUE_SUCCESS";
export const FETCH_LEASING_REVENUE_FAILED = "FETCH_LEASING_REVENUE_FAILED";
export const FETCH_LEASING_REVENUE_START = "FETCH_LEASING_REVENUE_START";
export const FETCH_IDEAL_DAYS_SUCCESS = "FETCH_IDEAL_DAYS_SUCCESS";
export const FETCH_IDEAL_DAYS_FAILED = "FETCH_IDEAL_DAYS_FAILED";
export const FETCH_IDEAL_DAYS_START = "FETCH_IDEAL_DAYS_START";
export const ASSET_REVENUE_REPORT_SUCCESS = "ASSET_REVENUE_REPORT_SUCCESS";
export const ASSET_REVENUE_REPORT_DOWNLOAD_START =
    "ASSET_REVENUE_REPORT_DOWNLOAD_START";
export const ASSET_REVENUE_REPORT_DOWNLOAD_STOP =
    "ASSET_REVENUE_REPORT_DOWNLOAD_STOP";
export const LEASING_COST_CALCULATION = "LEASING_COST_CALCULATION";
export const FETCH_LEASING_CALCULATION_SUCCESS =
    "FETCH_LEASING_CALCULATION_SUCCESS";

// Contract
export const GET_CONTRACT_SUCCESS = "GET_CONTRACT_SUCCESS";
export const FETCH_CONTRACT_SUCCESS = "FETCH_CONTRACT_SUCCESS";
export const CREATE_CONTRACT_SUCCESS = "CREATE_CONTRACT_SUCCESS";
export const SAVE_CONTRACT_QUERY = "SAVE_CONTRACT_QUERY";
export const GET_CONTRACT_LOCATIONS = "GET_CONTRACT_LOCATIONS";
export const SET_CONTRACT_UPLOAD = "SET_CONTRACT_UPLOAD";
export const UPLOAD_CONTRACT_DOCUMENT_SUCCESS =
    "UPLOAD_CONTRACT_DOCUMENT_SUCCESS";

// Asset Make

export const GET_ASSET_MAKE_SUCCESS = "GET_ASSET_MAKE_SUCCESS";
export const FETCH_ASSET_MAKE_SUCCESS = "FETCH_ASSET_MAKE_SUCCESS";
export const CREATE_ASSET_MAKE_SUCCESS = "CREATE_ASSET_MAKE_SUCCESS";
export const SAVE_ASSET_MAKE_QUERY = "SAVE_ASSET_MAKE_QUERY";// Asset Make


// AUDIT VOUCHERS
export const GET_AUDIT_VOUCHER_SUCCESS = "GET_AUDIT_VOUCHER_SUCCESS";
export const FETCH_AUDIT_VOUCHER_SUCCESS = "FETCH_AUDIT_VOUCHER_SUCCESS";
export const CREATE_AUDIT_VOUCHER_SUCCESS = "CREATE_AUDIT_VOUCHER_SUCCESS";
export const SAVE_AUDIT_VOUCHER_QUERY = "SAVE_AUDIT_VOUCHER_QUERY";
export const GET_AUDIT_VOUCHER_SEARCH_SUCCESS = "GET_AUDIT_VOUCHER_SEARCH_SUCCESS";
export const GET_AUDIT_VOUCHER_SEARCH_START = "GET_AUDIT_VOUCHER_SEARCH_START";
export const GET_AUDIT_VOUCHER_SEARCH_END = "GET_AUDIT_VOUCHER_SEARCH_END";

export const GET_FUEL_ADJUSTMENT_SUCCESS = "GET_FUEL_ADJUSTMENT_SUCCESS";
export const FETCH_FUEL_ADJUSTMENT_SUCCESS = "FETCH_FUEL_ADJUSTMENT_SUCCESS";
export const CREATE_FUEL_ADJUSTMENT_SUCCESS = "CREATE_FUEL_ADJUSTMENT_SUCCESS";
export const SAVE_FUEL_ADJUSTMENT_QUERY = "SAVE_FUEL_ADJUSTMENT_QUERY";

// Asset Manager

export const GET_ASSET_MANAGER_SUCCESS = "GET_ASSET_MANAGER_SUCCESS";
export const FETCH_ASSET_MANAGER_SUCCESS = "FETCH_ASSET_MANAGER_SUCCESS";
export const CREATE_ASSET_MANAGER_SUCCESS = "CREATE_ASSET_MANAGER_SUCCESS";
export const SAVE_ASSET_MANAGER_QUERY = "SAVE_ASSET_MANAGER_QUERY";

// Attendance

export const GET_ATTENDANCE_SUCCESS = "GET_ATTENDANCE_SUCCESS";
export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
export const CREATE_ATTENDANCE_SUCCESS = "CREATE_ATTENDANCE_SUCCESS";
export const SAVE_ATTENDANCE_QUERY = "SAVE_ATTENDANCE_QUERY";

// Asset Classification

export const GET_ASSET_CLASSIFICATION_SUCCESS = "GET_ASSET_CLASSIFICATION_SUCCESS";
export const FETCH_ASSET_CLASSIFICATION_SUCCESS = "FETCH_ASSET_CLASSIFICATION_SUCCESS";
export const CREATE_ASSET_CLASSIFICATION_SUCCESS = "CREATE_ASSET_CLASSIFICATION_SUCCESS";
export const SAVE_ASSET_CLASSIFICATION_QUERY = "SAVE_ASSET_CLASSIFICATION_QUERY";

// Asset Tag Type

export const GET_ASSET_TAG_TYPE_SUCCESS = "GET_ASSET_TAG_TYPE_SUCCESS";
export const GET_ALL_ASSET_TAG_TYPE_SUCCESS = "GET_ALL_ASSET_TAG_TYPE_SUCCESS";
export const FETCH_ASSET_TAG_TYPE_SUCCESS = "FETCH_ASSET_TAG_TYPE_SUCCESS";
export const CREATE_ASSET_TAG_TYPE_SUCCESS = "CREATE_ASSET_TAG_TYPE_SUCCESS";
export const SAVE_ASSET_TAG_TYPE_QUERY = "SAVE_ASSET_TAG_TYPE_QUERY";

// Asset Tag Attribute

export const GET_ASSET_TAG_ATTRIBUTE_SUCCESS = "GET_ASSET_TAG_ATTRIBUTE_SUCCESS";
export const GET_ALL_ASSET_TAG_ATTRIBUTE_SUCCESS = "GET_ALL_ASSET_TAG_ATTRIBUTE_SUCCESS";
export const FETCH_ASSET_TAG_ATTRIBUTE_SUCCESS = "FETCH_ASSET_TAG_ATTRIBUTE_SUCCESS";
export const CREATE_ASSET_TAG_ATTRIBUTE_SUCCESS = "CREATE_ASSET_TAG_ATTRIBUTE_SUCCESS";
export const SAVE_ASSET_TAG_ATTRIBUTE_QUERY = "SAVE_ASSET_TAG_ATTRIBUTE_QUERY";

// Asset Link

export const GET_ASSET_LINK_SUCCESS = "GET_ASSET_LINK_SUCCESS";
export const GET_ASSET_LINK_SEARCH_SUCCESS = "GET_ASSET_LINK_SEARCH_SUCCESS";
export const FETCH_ASSET_LINK_SUCCESS = "FETCH_ASSET_LINK_SUCCESS";
export const FETCH_ASSET_LINK_BY_CODE_SUCCESS = "FETCH_ASSET_LINK_BY_CODE_SUCCESS";
export const CREATE_ASSET_LINK_SUCCESS = "CREATE_ASSET_LINK_SUCCESS";
export const SAVE_ASSET_LINK_QUERY = "SAVE_ASSET_LINK_QUERY";
export const RESET_ASSET_LINK_SUCCESS = "RESET_ASSET_LINK_SUCCESS";


export const GET_IDEAL_ASSET_COUNT_SUCCESS = "GET_IDEAL_ASSET_COUNT_SUCCESS";
export const GET_IDEAL_ASSET_COUNT_START = "GET_IDEAL_ASSET_COUNT_START";

export const GET_VERIFIED_ASSET_COUNT_SUCCESS = "GET_VERIFIED_ASSET_COUNT_SUCCESS";
export const GET_VERIFIED_ASSET_COUNT_START = "GET_VERIFIED_ASSET_COUNT_START";

export const GET_ATA_COUNT_SUCCESS = "GET_ATA_COUNT_SUCCESS";
export const GET_ATA_COUNT_START = "GET_ATA_COUNT_START";
export const UPLOAD_ATA_DATA_SUCCESS = 'UPLOAD_ATA_DATA_SUCCESS';

export const GET_STA_COUNT_SUCCESS = "GET_STA_COUNT_SUCCESS";
export const GET_STA_COUNT_START = "GET_STA_COUNT_START";

export const GET_JOB_CARD_DASHBOARD_DOWNLOAD_SUCCESS = "GET_JOB_CARD_DASHBOARD_DOWNLOAD_SUCCESS";
export const GET_JOB_CARD_DASHBOARD_DOWNLOAD_START = "GET_JOB_CARD_DASHBOARD_DOWNLOAD_START";

export const GET_ASSET_FROM_QR_SUCCESS = "GET_ASSET_FROM_QR_SUCCESS";
export const GET_ASSET_FROM_CODE_SUCCESS = "GET_ASSET_FROM_CODE_SUCCESS";
export const GET_ASSET_LAST_IMAGE_SUCCESS = "GET_ASSET_LAST_IMAGE_SUCCESS";
export const GET_ASSET_IMAGES_SUCCESS = "GET_ASSET_IMAGES_SUCCESS";
export const GET_ASSET_DEVICE_LAST_DATA_SUCCESS = "GET_ASSET_DEVICE_LAST_DATA_SUCCESS";
export const GET_ASSET_DEVICE_FUEL_DATA_SUCCESS = "GET_ASSET_DEVICE_FUEL_DATA_SUCCESS";
export const GET_ASSET_DEVICE_RANGE_DATA_SUCCESS = "GET_ASSET_DEVICE_RANGE_DATA_SUCCESS";
export const GET_TAGGED_DEVICE_DATA_SUCCESS = "GET_TAGGED_DEVICE_DATA_SUCCESS";
export const FETCH_DEVICE_FUEL_START = "FETCH_DEVICE_FUEL_START";
export const FETCH_DEVICE_FUEL_END = "FETCH_DEVICE_FUEL_END";
export const GET_ASSET_DEVICE_DAILY_FUEL_DATA_SUCCESS = "GET_ASSET_DEVICE_DAILY_FUEL_DATA_SUCCESS";
export const FETCH_DEVICE_DAILY_FUEL_START = "FETCH_DEVICE_DAILY_FUEL_START";
export const FETCH_DEVICE_DAILY_FUEL_END = "FETCH_DEVICE_DAILY_FUEL_END";
export const GET_RECONCILIATION_ASSETS_SUCCESS = "GET_RECONCILIATION_ASSETS_SUCCESS";
export const SAVE_RECONCILIATION_ASSETS_SUCCESS = "SAVE_RECONCILIATION_ASSETS_SUCCESS";
export const SAVE_RECONCILIATION_PV_ASSETS_SUCCESS = "SAVE_RECONCILIATION_PV_ASSETS_SUCCESS";
export const PROCESS_RECONCILIATION_ASSETS_SUCCESS = "PROCESS_RECONCILIATION_ASSETS_SUCCESS";
export const PROCESS_RECONCILIATION_PV_ASSETS_SUCCESS = "PROCESS_RECONCILIATION_PV_ASSETS_SUCCESS";
export const SAVE_RECONCILIATION_ASSET_ASSETS_SUCCESS = "SAVE_RECONCILIATION_ASSET_ASSETS_SUCCESS";
export const PROCESS_RECONCILIATION_ASSET_ASSETS_SUCCESS = "PROCESS_RECONCILIATION_ASSET_ASSETS_SUCCESS";
export const PROCESS_DEVICE_DAILY_FUEL_DATA_IN_PERIOD_SUCCESS = "PROCESS_DEVICE_DAILY_FUEL_DATA_IN_PERIOD_SUCCESS";

//Tasks
export const GET_TASK_SUCCESS = "GET_TASK_SUCCESS";
export const CREATE_TASK_SUCCESS = "CREATE_TASK_SUCCESS";
export const FETCH_TASK_SUCCESS = "FETCH_TASK_SUCCESS";
export const SAVE_TASK_QUERY = "SAVE_TASK_QUERY";
export const FETCH_TASK_SEARCH_SUCCESS = "FETCH_TASK_SEARCH_SUCCESS";
//Tasks action
export const GET_TASK_ACTION_SUCCESS = "GET_TASK_ACTION_ACTION_SUCCESS";
export const CREATE_TASK_ACTION_SUCCESS = "CREATE_TASK_ACTION_SUCCESS";
export const FETCH_TASK_ACTION_SUCCESS = "FETCH_TASK_ACTION_SUCCESS";
export const SAVE_TASK_ACTION_QUERY = "SAVE_TASK_ACTION_QUERY";
//Tasks Component
export const GET_TASK_COMPONENT_SUCCESS = "GET_TASK_COMPONENT_SUCCESS";
export const CREATE_TASK_COMPONENT_SUCCESS = "CREATE_TASK_COMPONENT_SUCCESS";
export const FETCH_TASK_COMPONENT_SUCCESS = "FETCH_TASK_COMPONENT_SUCCESS";
export const SAVE_TASK_COMPONENT_QUERY = "SAVE_TASK_COMPONENT_QUERY";
//Service Identifier
export const GET_SERVICE_IDENTIFIER_SUCCESS = "GET_SERVICE_IDENTIFIER_SUCCESS";
export const GET_SERVICE_IDENTIFIER_FROM_ASSET_SUCCESS = "GET_SERVICE_IDENTIFIER_FROM_ASSET_SUCCESS";
export const CREATE_SERVICE_IDENTIFIER_SUCCESS = "CREATE_SERVICE_IDENTIFIER_SUCCESS";
export const FETCH_SERVICE_IDENTIFIER_SUCCESS = "FETCH_SERVICE_IDENTIFIER_SUCCESS";
export const SAVE_SERVICE_IDENTIFIER_QUERY = "SAVE_SERVICE_IDENTIFIER_QUERY";
//Preventive Maintenance
export const GET_PREVENTIVE_MAINTENANCE_SUCCESS = "GET_PREVENTIVE_MAINTENANCE_SUCCESS";
export const CREATE_PREVENTIVE_MAINTENANCE_SUCCESS = "CREATE_PREVENTIVE_MAINTENANCE_SUCCESS";
export const FETCH_PREVENTIVE_MAINTENANCE_SUCCESS = "FETCH_PREVENTIVE_MAINTENANCE_SUCCESS";
export const SAVE_PREVENTIVE_MAINTENANCE_QUERY = "SAVE_PREVENTIVE_MAINTENANCE_QUERY";
export const FETCH_PREVENTIVE_MAINTENANCE_LAST_PROCESSED_SUCCESS = "FETCH_PREVENTIVE_MAINTENANCE_LAST_PROCESSED_SUCCESS";
export const PREVENTIVE_MAINTENANCE_TASK_UPDATE_SUCCESS = 'PREVENTIVE_MAINTENANCE_TASK_UPDATE_SUCCESS';
export const PREVENTIVE_MAINTENANCE_PROCESS_SUCCESS = 'PREVENTIVE_MAINTENANCE_PROCESS_SUCCESS';

//Page Setting
export const GET_PAGE_SETTING_SUCCESS = "GET_PAGE_SETTING_SUCCESS";
export const FETCH_PAGE_SETTING_SUCCESS = "FETCH_PAGE_SETTING_SUCCESS";
export const FETCH_PAGE_SETTING_FOR_PAGE_SUCCESS = "FETCH_PAGE_SETTING_FOR_PAGE_SUCCESS";
export const CREATE_PAGE_SETTING_SUCCESS = "CREATE_PAGE_SETTING_SUCCESS";
export const SAVE_PAGE_SETTING_QUERY = "SAVE_PAGE_SETTING_QUERY";


export const GET_BACKGROUND_JOB_SUCCESS = "GET_BACKGROUND_JOB_SUCCESS";

export const CREATE_FUEL_SENSOR_CALIBRATION_SUCCESS = 'CREATE_FUEL_SENSOR_CALIBRATION_SUCCESS';
export const GET_FUEL_SENSOR_CALIBRATION_SUCCESS = 'GET_FUEL_SENSOR_CALIBRATION_SUCCESS';

//Iot Device
export const GET_DEVICE_SUCCESS = 'GET_DEVICE_SUCCESS';
export const FETCH_DEVICE_SUCCESS = 'FETCH_DEVICE_SUCCESS';
export const CREATE_DEVICE_SUCCESS = 'CREATE_DEVICE_SUCCESS';
export const SAVE_DEVICE_QUERY = 'SAVE_DEVICE_QUERY';

